<template>
    <div class="">
        <div class="mb-4">
            <span class="text-sm font-bold text-gray-500">01.</span>
        </div>
        <div class="mb-4">
            <span class="text-5xl font-extrabold tracking-tight">Deur.</span>
        </div>
        <div class="mb-4">
            <span class="text-xl font-extrabold tracking-tight">Type</span>
        </div>
            <div class="grid grid-cols-2 gap-4 mb-8 lg:grid-cols-4 xl:grid-cols-2"> 
                <div
                    v-for="(doorType, index) in doorTypes"
                    :key="index"
                >
                    <div
                        class="pl-4 transition duration-300 ease-in-out border-l-4 border-transparent group hover:border-black"
                        @click="setDoorType(), checkDoorWidth()"
                        :id="doorTypes[index].type"
                        :class="$store.state.doorType === doorTypes[index].type ? ['border-black', 'text-black'] : ['border-transparent', 'text-gray-500']"
                    >
                        <img
                            :src="doorTypes[index].icon"
                            class="w-32 transition duration-300 ease-in-out cursor-pointer group-hover:text-black"
                            alt="scharnierdeur"
                        >
                        <span
                            class="tracking-wider transition duration-300 ease-in-out cursor-pointer group-hover:text-black"
                        >
                            {{  doorTypes[index].typeNl }}
                        </span>
                    </div>
                </div>
            </div>
        <div class="mb-4">
            <span class="text-xl font-extrabold tracking-tight">Afmetingen</span>
        </div>
        <div class="ml-4">    
            <div class="mb-4">
                <label class="text-sm font-bold text-gray-500">Lengte 
                    <span
                        class="text-xs text-gray-400"
                        :class="doorSizeError.status === true ? 'text-red-500' : 'text-gray-400'"
                    >
                        (max. {{ doorHeightMax }} cm.)
                    </span>
                </label>
                <div class="inline-flex items-center w-full mt-2 border">
                    <div class="w-12 py-2 text-center bg-gray-100">
                        <i class="w-6 text-gray-500 far fa-ruler-vertical"></i>
                    </div>
                    <input 
                        class="w-full p-2 focus:outline-none focus:text-black" 
                        id="door-length" 
                        v-model.lazy="doorHeightInput"
                        type="number" 
                        placeholder="Lengte"
                        :min="doorHeightMin"
                        :max="doorHeightMax"
                        @change="checkDoorWidth(), checkDoorSizeError()"
                    >
                    <div class="w-12 py-2 text-center bg-gray-100">
                        <span class="text-sm text-gray-500">cm.</span>
                    </div>
                </div>
            </div>
            <div class="mb-4">
                <label class="text-sm font-bold text-gray-500">
                    Breedte 
                    <span
                        class="text-xs"
                        :class="doorSizeError.status === true ? 'text-red-500' : 'text-gray-400'"
                    >
                        (max. {{ doorWidthMax }} cm.)
                    </span>
                </label>
                <div class="inline-flex items-center w-full mt-2 border">
                    <div class="w-12 py-2 text-center bg-gray-100">
                        <i class="w-6 text-gray-500 far fa-ruler-horizontal"></i>
                    </div>
                    <input 
                        class="w-full p-2 focus:outline-none focus:text-black" 
                        id="door-width" 
                        v-model.lazy="doorWidthInput"
                        type="number" 
                        placeholder="Breedte"
                        :min="doorWidthMin"
                        :max="doorWidthMax"
                        @change="checkDoorWidth(), checkDoorSizeError()"
                    >
                    <div class="w-12 py-2 text-center bg-gray-100">
                        <span class="text-sm text-gray-500">cm.</span>
                    </div>
                </div>
            </div>
            <div class="mb-4 text-xs text-red-500" v-if="doorSizeError.status === true">{{ doorSizeError.text }}</div>
        </div>
        <div class="mb-4">
            <span class="text-xl font-extrabold tracking-tight">Aantal</span>
        </div>
        <div class="ml-4">
            <div class="inline-flex mb-4">
                <button 
                    class="px-4 py-2 mr-2 font-bold transition duration-300 ease-in-out border hover:bg-vida-dark hover:text-white"
                    :class="doorAmount === index + 1 ? ['bg-vida-dark', 'text-white'] : 'bg-gray-100'"
                    v-for="(doorAmoutButton, index) in doorAmoutButtons"
                    :key="index"
                    @click="setDoorAmount(index)"
                >
                    {{ index + 1 }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapMutations } from 'vuex'

    export default {
        data() {
            return {
                doorAmoutButtons: 2,
                doorSizeError: {
                    status: false,
                    text: 'De ingegeven afmetingen vallen buiten de mogelijkheden. De waarden werden automatisch aangepast aan de maximale mogelijke afmetingen voor de door u geconfigureerde hoogte of breedte.'
                },
                doorTypes: [
                    { 
                        id: 1,
                        type: 'hinge',
                        typeNl: 'Scharnierdeur',
                        icon: require('../../assets/images/svg/scharnierdeur_l.svg')
                     },
                     { 
                        id: 2,
                        type: 'pivot',
                        typeNl: 'Pivotdeur',
                        icon: require('../../assets/images/svg/pivotdeur.svg')
                     },
                     { 
                        id: 3,
                        type: 'slide',
                        typeNl: 'Schuifdeur',
                        icon: require('../../assets/images/svg/schuifdeur.svg')
                     },
                     { 
                        id: 4,
                        type: 'fixed',
                        typeNl: 'Vast paneel',
                        icon: require('../../assets/images/svg/vastpaneel.svg')
                     }
                ],

            }
        },
        methods: {
            ...mapMutations([
                'setDoorType',
                'setDoorHeight',
                'setDoorWidth',
                'setDoorWidthMin',
                'setDoorWidthMax',
                'setDoorBeamAmount',
                'setDoorUprightAmount',
                'setDoorAmount'
            ]),
            checkDoorSizeError() {
                if(this.doorHeight > this.doorHeightMax || this.doorWidth > this.doorWidthMax) {
                    this.doorSizeError.status = true
                } else {
                    this.doorSizeError.status = false
                } 
            },
            checkDoorWidth() {
                if(this.doorHeight >= 190 && this.doorHeight <= 220) {
                    if(this.doorType === 'hinge') {
                        this.$store.commit('setDoorWidthMax', 110)
                    } else if(this.doorType === 'pivot' || this.doorType === 'slide') {
                        this.$store.commit('setDoorWidthMax', 140)
                    } else if(this.doorType === 'fixed') {
                        this.$store.commit('setDoorWidthMax', 150)
                    }
                } else if(this.doorHeight >= 221 && this.doorHeight <= 250) {
                    if(this.doorType === 'hinge') {
                        this.$store.commit('setDoorWidthMax', 100)
                    } else if(this.doorType === 'pivot' || this.doorType === 'slide') {
                        this.$store.commit('setDoorWidthMax', 120)
                    } else if(this.doorType === 'fixed') {
                        this.$store.commit('setDoorWidthMax', 150)
                    }
                } else if(this.doorHeight >= 251 && this.doorHeight <= 280) {
                    if(this.doorType === 'hinge') {
                        this.$store.commit('setDoorWidthMax', 90)
                    } else if(this.doorType === 'pivot' || this.doorType === 'slide') {
                        this.$store.commit('setDoorWidthMax', 110)
                    } else if(this.doorType === 'fixed') {
                        this.$store.commit('setDoorWidthMax', 150)
                    } 
                } else if(this.doorHeight >= 281 && this.doorHeight <= 300) {
                    if(this.doorType === 'hinge') {
                        this.$store.commit('setDoorWidthMax', 90)
                    } else if(this.doorType === 'pivot' || this.doorType === 'slide') {
                        this.$store.commit('setDoorWidthMax', 100)
                    } else if(this.doorType === 'fixed') {
                        this.$store.commit('setDoorWidthMax', 150)
                    }
                }
            } 
        },
        computed: {
            ...mapState([
                'doorType',
                'doorAmount',
                'doorHeight',
                'doorWidth',
                'doorHeightMin',
                'doorHeightMax',
                'doorWidthMin',
                'doorWidthMax',
                'doorUprightAmount',
                'doorBeamAmount',
            ]),
            doorHeightInput: {
                get () {
                    return this.$store.state.doorHeight
                },
                set (value) {
                    this.$store.commit('setDoorHeight', value)
                }
            },
            doorWidthInput: {
                get () {
                    return this.$store.state.doorWidth
                },
                set (value) {
                    this.$store.commit('setDoorWidth', value)
                },
            }
        },
        watch: {
            doorHeightInput() {
                if(this.doorHeight > this.doorHeightMax) {
                    this.$store.commit('setDoorHeight', this.doorHeightMax)
                    this.doorSizeError.status = true
                } else if (this.doorHeight < this.doorHeightMin) {
                    this.$store.commit('setDoorHeight', this.doorHeightMin)
                    this.doorSizeError.status = true
                } 
            },
            doorWidthInput() {
                if(this.doorWidth > this.doorWidthMax) {
                    this.$store.commit('setDoorWidth', this.doorWidthMax)
                    this.doorSizeError.status = true
                } else if (this.doorWidth < this.doorWidthMin) {
                    this.$store.commit('setDoorWidth', this.doorWidthMin)
                    this.doorSizeError.status = true
                }
            }   
        } 
    }
</script>

<style>

</style>